import { GetPlaceTopWaters_entry_edges_node } from '../../../interfaces/graphql';

const FILTER_REVIEWS_THRESHOLD = 3;
const FILTER_CATCHES_THRESHOLD = 10;

/**
 * Filters fishing waters based on various criteria such as review average or catch count.
 *
 * @param fishingWater - The fishing water entry to be filtered.
 * @returns `true` if the fishing water passes all the filters, `false` otherwise.
 *
 * The filtering criteria are:
 * - The average review score must be greater than or equal to `FILTER_REVIEWS_THRESHOLD`.
 * - The total catch count must be greater than or equal to `FILTER_CATCHES_THRESHOLD`.
 */
export const filterFishingWaters = (fishingWater: GetPlaceTopWaters_entry_edges_node) => {
  const catchCount = fishingWater.catchesCount;
  const reviewAverage = fishingWater.allReviews?.totalAverage ?? 0;

  if (reviewAverage > 0 && reviewAverage < FILTER_REVIEWS_THRESHOLD) {
    return false;
  }

  if (catchCount < FILTER_CATCHES_THRESHOLD) {
    return false;
  }

  return true;
};
